import React from 'react'
import PropTypes from 'prop-types'
import { translate, Label } from 'parking-react-common'

import { events, users, filters } from '../redux'

import List from '../components/List'
import UserDisplay from '../components/UserDisplay'
import TZDateTime from './TZDateTime'

const EventsList = ({ title, subtitle, dataURL, dataSelector, t }) => {
    const columns = [
        {
            key    : 'type',
            title  : t('Type'),
            render : ({ cellData }) =>  (// eslint-disable-line react/prop-types
                <Label scope="events.type">{ cellData }</Label>
            )
        },
        {
            key    : 'moment',
            title  : t('Moment'),
            render : ({ cellData }) => ( // eslint-disable-line react/prop-types
                <TZDateTime input={ cellData } />
            )
        },
        {
            key    : 'user',
            title  : t('User'),
            render : ({ cellData }) => ( // eslint-disable-line react/prop-types
                <UserDisplay user={ cellData } />
            )
        }
    ]

    const searchKeys = ['type', ...users.getSearchKeys()]
    const filterKeys = {
        moment: filters.TYPES.dateRange
    }

    return (
        <List
            title={ title || t('Events') }
            subtitle={ subtitle }
            columns={ columns }
            dataURL={ dataURL }
            dataSelector={ dataSelector }
            searchKeys={ searchKeys }
            filterKeys={ filterKeys }
        />
    )
}

EventsList.propTypes = {
    title        : PropTypes.node,
    subtitle     : PropTypes.node,
    dataSelector : PropTypes.func,
    dataURL      : PropTypes.string
}

EventsList.defaultProps = {
    dataSelector : events.getAll,
    dataURL      : 'events'
}

export default translate()(EventsList)
